module.exports = __webpack_public_path__ + "static/cercazone_sudest5-c63bbdacd793323d02e982af4736935b.jpg";